import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import axiosInstance from "../../shared/service/axios";
import {
  SupplierAddRequest,
  SupplierAddResponse,
  SupplierListResponse,
  SupplierPaymentRequest,
  SupplierPaymentResponse,
  SupplierUpdateRequest,
  SupplierUpdateResponse,
} from "./Supplier.constants";

export const useSupplierAddMutation = (): UseMutationResult<
  SupplierAddResponse,
  AxiosError,
  SupplierAddRequest
> =>
  useMutation<SupplierAddResponse, AxiosError, SupplierAddRequest>(
    async (requestValues: SupplierAddRequest) => {
      const { data, status } = await axiosInstance.post(
        "supplier/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useSupplierUpdateMutation = (): UseMutationResult<
  SupplierUpdateResponse,
  AxiosError,
  SupplierUpdateRequest
> =>
  useMutation<SupplierUpdateResponse, AxiosError, SupplierUpdateRequest>(
    async (requestValues: SupplierUpdateRequest) => {
      const { data, status } = await axiosInstance.put(
        "supplier/" + requestValues.id + "/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useSupplierDeleteMutation = (): UseMutationResult<
  any,
  AxiosError,
  string
> =>
  useMutation<any, AxiosError, string>(async (requestValues: string) => {
    const { status } = await axiosInstance.delete(
      "supplier/" + requestValues + "/"
    );

    return status;
  });

export const useSupplierListMutation = (): UseMutationResult<
  SupplierListResponse,
  AxiosError,
  any
> =>
  useMutation<SupplierListResponse, AxiosError, any>(async () => {
    const { data, status } = await axiosInstance.get("supplier/");

    return data;
  });

export const useSupplierPaymentsMutation = (): UseMutationResult<
  SupplierPaymentResponse,
  AxiosError,
  SupplierPaymentRequest
> =>
  useMutation<SupplierPaymentResponse, AxiosError, SupplierPaymentRequest>(
    async (requestValues: SupplierPaymentRequest) => {
      const { data, status } = await axiosInstance.get(
        "supplier/" + requestValues.id + "/payments/"
      );
      data.status = status;

      return data;
    }
  );
